import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-card-obligacion',
  templateUrl: './card-obligacion.component.html',
  styleUrls: ['./card-obligacion.component.scss']
})
export class CardObligacionComponent implements OnInit {

  @Input() tipoCumplimiento: string;
  @Input() tipoObligacion: string;
  @Input() obligacionName: string;
  @Input() rectificativa: number;

  constructor() { }

  ngOnInit(): void {
  }

}
